// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./plugins/router";
import Vuetify from "vuetify";
import { sync } from "vuex-router-sync";
import i18n from "@/plugins/i18n";
import "vuetify/dist/vuetify.min.css";
import store from "@/plugins/store/store";
import Panel from "@/components/globals/Panel";
import SearchBar from "@/components/globals/SearchBar";
import DateTimePickerWithZone from "@/components/_datetimepicker"; // for date picker
import dateFns from "date-fns";
import "vue-datetime/dist/vue-datetime.css";
import DatePicker from 'vue2-datepicker';
import { PulseLoader } from 'vue-spinner/dist/vue-spinner.min.js'
import 'vue2-datepicker/index.css';
import moment from "moment-timezone";
import TimezoneSelector from "./components/_timezone-selector";
import SensitivitySelector from "./components/_sensitivity-selector";

import 'vue2-datepicker/locale/en';
import 'vue2-datepicker/locale/hu';
import 'vue2-datepicker/locale/it';
import 'vue2-datepicker/locale/nl';
import 'vue2-datepicker/locale/pl';
import 'vue2-datepicker/locale/ru';
import 'vue2-datepicker/locale/sl';
import 'vue2-datepicker/locale/de';
import 'vue2-datepicker/locale/fr';

Vue.config.productionTip = false;

// Set theme based on domain
Object.defineProperty(Vue.prototype, "$hwUrl", {value: process.env.HERDWATCH_URL.toLocaleLowerCase() });
Object.defineProperty(Vue.prototype, "$domain", {value: (window.location.hostname+":"+window.location.port).toLocaleLowerCase() });

const background = `url(${require('@/assets/msyst-web-bg.jpg')}) repeat`;

const themes = {
  default: {
    primary: "#6A7D9B",
    primary_header: "#6A7D9B",
    secondary: "#FF6D34",
    secondary_original: "#FF6D34",
    accent: "#393F4F",
    accent_original: "#393F4F",
    sidebar_active: "#393F4F",
    error: "#b71c1c",
    background: background,
    bg_login: background,
    // Used for dismiss but assigned to this because this is an internal Vue style
    warning: "#6A7D9B"
  }
};
themes["herdwatch"] = {...themes.default, ...{
  primary_header: "#001738",
  primary: "#8E44AD",
  secondary: "#007db5",
  accent: "#b5c426",
  sidebar_active: "#394150",
  warning: "#001738",
  bg_login: '#001738',
  background: '#fafafa'
}};

let theme_active = "default";
if (Vue.prototype.$domain === Vue.prototype.$hwUrl) {
  theme_active = "herdwatch";
  // Set page title for Herdwatch domain
  document.title = "Sensors by Herdwatch";
}
Vue.use(Vuetify, { theme: themes[theme_active] });

// Set theme colors via CSS variables
Object.entries(themes[theme_active]).forEach(([key, color]) => {
  document.documentElement.style.setProperty("--v-" + key, color);
});

Vue.use(DatePicker);
Vue.prototype.dateFns = dateFns;
Object.defineProperty(Vue.prototype, "dateFns", { value: dateFns });

// Keep i18n locale in sync with the store (and persisted state on refresh)
i18n.locale = (store.state && store.state.locale) ? store.state.locale : "en";
store.watch(
  state => state.locale,
  locale => {
    if (locale) {
      i18n.locale = locale;
      moment.locale(locale);
    }
  }
);

store.state.user && store.state.user.timezone
  ? moment.tz.setDefault(store.state.user.timezone)
  : moment.tz.guess(true);

store.state.locale ? moment.locale(store.state.locale) : moment.locale("en");
Object.defineProperty(Vue.prototype, "$moment", { value: moment });
Object.defineProperty(Vue.prototype, "$dateFormat", { value: "D MMM YYYY" });
Object.defineProperty(Vue.prototype, "$dateTimeFormat", {
  value: "D MMM YYYY HH:mm "
});

Vue.component("panel", Panel);
Vue.component("search-bar", SearchBar);
Vue.component("date-time-picker-with-zone", DateTimePickerWithZone);
Vue.component("timezone-selector", TimezoneSelector);
Vue.component("sensitivity-selector", SensitivitySelector);
Vue.component('pulse-loader', PulseLoader);

Vue.filter("capitalize", function (value) {
  if (!value) return "";
  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1);
});

sync(store, router);

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  i18n,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js